import ImageSlot from '../shared/ImageSlot.jsx';
import Reveal from '../shared/Reveal.jsx';
import { useTeachers } from '../content/useContent.js';

/**
 * The four teacher cards, without the homepage section's heading and button.
 * Reads the same API-backed content as `sections/Teachers.jsx`, so a name
 * edited in the dashboard changes on both pages.
 */
export default function TeacherGrid() {
  const teachers = useTeachers();

  return (
    <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
      {teachers.map((teacher, i) => (
        <Reveal
          key={teacher.name}
          index={i}
          className="rounded-[26px] border-[3px] border-forest bg-white p-[18px] shadow-[0_9px_0_rgb(20_83_45_/_0.12)]"
        >
          <div className="aspect-square overflow-hidden rounded-[20px] bg-mint">
            <ImageSlot
              src={teacher.photo}
              name={teacher.name}
              alt={`${teacher.name}, ${teacher.role}`}
            />
          </div>
          <h3 className="mt-3.5 font-display text-[21px] font-extrabold text-forest">
            {teacher.name}
          </h3>
          <p className="text-sm font-bold text-coral">{teacher.role}</p>
          <p className="mt-2 text-[14.5px] leading-[1.5] text-ink-soft">{teacher.quote}</p>
        </Reveal>
      ))}
    </div>
  );
}
